<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-1">
      <div class="breadcrumb-title border-0">
        <app-list-header [title]="'App Users'" icon="bx bx-group" [$parent]="getSelf()">
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form class="row mb-2 gx-2 gy-2 align-items-center">
            <div class="col-auto">
              <select [(ngModel)]="form.searchParams['applicationId']"
                [ngClass]="{ 'placeholder-grey': form.searchParams['applicationId'] === undefined }"
                class="form-select form-select-sm" id="applicationId" name="applicationId"
                (change)="convertStrToNumUser(form.searchParams['applicationId'], 'applicationId')"
                data-placeholder="Choose a state" (change)="getApplicationRoles()">
                <option value="undefined" disabled>
                  --Select application--
                </option>
                <option *ngFor="let e of form.preload?.['cuickdev.application']" [value]="e['id']">
                  {{ e["_val"] }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <select [(ngModel)]="form.searchParams['applicationRoleId']"
                [disabled]="form.searchParams['applicationId'] === undefined"
                (change)="convertStrToNumUser(form.searchParams['applicationRoleId'], 'applicationRoleId')"
                [ngClass]="{ 'placeholder-grey': form.searchParams['applicationRoleId'] === undefined }"
                class="form-select form-select-sm" id="applicationRoleId" name="applicationRoleId"
                data-placeholder="Choose a state">
                <option value="undefined" disabled>--Select role--</option>
                <option *ngFor="let e of applicationRoles" [value]="e['id']">
                  {{ e["name"] }}
                </option>
              </select>
            </div>
            <div class="col-auto">
              <input [(ngModel)]="form.searchParams['userFirstname']"
                [disabled]="form.searchParams['applicationId'] === undefined" id="userFirstname" name="userFirstname"
                placeholder="Enter user name" class="form-control form-control-sm" type="text" />
            </div>
            <div class="col-auto">
              <input [(ngModel)]="form.searchParams['email']"
                [disabled]="form.searchParams['applicationId'] === undefined" id="email" name="email"
                placeholder="Enter email" class="form-control form-control-sm" type="text" />
            </div>
            <div class="col-auto">
              <select [(ngModel)]="form.searchParams['status']"
                [disabled]="form.searchParams['applicationId'] === undefined"
                [ngClass]="{ 'placeholder-grey': form.searchParams['status'] === undefined }"
                class="form-select form-select-sm" id="status" name="status">
                <option value="undefined" disabled>--Select status--</option>
                <option value="Accept">Accept</option>
                <option value="Reject">Reject</option>
                <option value="Pending">Pending</option>
                <option value="Cancel">Cancel</option>
              </select>
            </div>
            <div class="col-auto">
              <button (click)="search()" class="btn btn-outline-primary btn-sm">
                <i class="fa fa-search-plus"></i> Search
              </button>
            </div>
            <div class="col-auto">
              <button (click)="resetSearchForm()" class="btn btn-outline-primary btn-sm" id="marginSet">
                <i class="fa fa-eraser" aria-hidden="true"></i>
              </button>
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-outline-primary app-btn" data-bs-toggle="modal" data-bs-target="#editModal"
                title="Add" (click)="get(0)">
                <i class="fa fa-plus"></i> Add
              </button>
            </div>
          </form>

          <!-- table form -->
          <div class="table-responsive mb-3">
            <p *ngIf="form['searchError'] == false && form['searchMessage']">
              <app-ncs-alert [message]="form['searchMessage']" type="success" />
            </p>
            <p *ngIf="form['searchError'] == true && form['searchMessage']">
              <app-ncs-alert [message]="form['searchMessage']" type="danger" />
            </p>
            <table class="table">
              <thead class="table-light">
                <tr>
                  <th>S.No.</th>
                  <th>Details</th>
                  <th>Application</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of form.list; let i = index">
                  <td>{{ pageIndex(i) }}</td>

                  <!-- Profile Picture and Name with URL -->
                  <td class="d-flex align-items-center">
                    <!-- <a [href]="getDoc(e['imageId'])" target="_blank">
                      <img [src]="getDocThumbnail(e['imageId'])" alt="Image Preview" class="rounded-circle me-3"
                        style="width: 50px; height: 50px; object-fit: cover;">
                    </a> -->
                    <div>
                      <span>{{ e.userFirstname }}</span>
                      <b> ({{ e.applicationRoleName }})</b>
                      <p class="text-muted mb-0" style="font-size: 0.875rem">
                        {{ e.email }}
                      </p>
                    </div>
                  </td>

                  <!-- Organization -->
                  <td>{{ e.applicationName | truncate }}</td>

                  <td>
                    <select [(ngModel)]="e.status" (change)="changeStatus(e.id, e.status)"
                      class="form-select form-select-sm" id="status" name="status">
                      <option value="" disabled>--Select--</option>
                      <option value="Accept">Accept</option>
                      <option value="Reject">Reject</option>
                      <option value="Pending">Pending</option>
                      <option value="Cancel">Cancel</option>
                    </select>
                  </td>

                  <!-- Actions -->
                  <td align="left">
                    <div class="d-flex align-items-center justify-content-start p-0 m-0">
                      <button title="Application Information" class="btn btn-sm btn-outline-primary me-1"
                        data-bs-toggle="modal" data-bs-target="#appInfo" (click)="appInfo = e">
                        <i class="fa fa-info-circle text-info fs-6 m-0 p-0"></i>
                      </button>

                      <!-- <button title="Edit" class="btn btn-sm btn-outline-primary me-1" data-bs-toggle="modal"
                        data-bs-target="#editModal" (click)="get(e)">
                        <i class="fa fa-edit fs-6 p-0"></i>
                      </button> -->

                      <button title="Delete" class="btn btn-sm btn-outline-danger me-1" (click)="delete(e.id)">
                        <i class="fa fa-trash fs-6 p-0"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- App User Modal -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Application Members</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="col-md-12">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <p class="text-center">{{ form.searchMessage }}</p>
          <form #uiForm="ngForm" class="d-flex align-items-center">
            <!-- Member Field -->
            <input type="email" class="form-control form-select-sm me-3" id="email" name="email" required
              #emailField="ngModel" placeholder="Email" [(ngModel)]="form.data['email']" style="width: 200px" (change)="
                checkDuplicate(
                  form.data['email'],
                  form.data['applicationRoleId'],
                  form.data['applicationId']
                )
              " />

            <!-- Email Error Message
            <span
              style="color: red"
              *ngIf="emailField.invalid && emailField.touched"
            >
              Invalid email format
            </span>  -->
            <!-- Email Error Message -->
            <span style="color: red" *ngIf="emailField.invalid && emailField.touched && emailField.value">
              Invalid email format
            </span>

            <!-- Applicaton Field -->
            <select #appid class="form-control form-select-sm me-3" id="applicationId"
              [disabled]="isSelectDisabled || form.data['email'] === undefined" (change)="getApplicationRole()"
              name="applicationId" [(ngModel)]="form.data['applicationId']" required style="width: 200px">
              <option selected disabled value="undefined">--Application Name--</option>

              <option *ngFor="let c of form.preload?.['cuickdev.application']" value="{{ c['id'] }}">
                {{ c["_val"] }}
              </option>
            </select>
            <!-- <span style="color:red" *ngIf="appid.invalid && appid.touched">
              Invalid application selected
            </span> -->

            <!-- <select
              #field
              class="form-control form-select-sm me-3"
              id="applicationRoleId"
              [disabled]="form.data['email'] === undefined"
              (change)="
                checkDuplicate(
                  form.data['email'],
                  form.data['applicationRoleId'],
                  form.data['applicationId']
                )
              "
              name="applicationRole"
              [(ngModel)]="form.data['applicationRoleId']"
              required
              style="width: 200px"
            >
              <option selected value="undefined">--Application Role--</option>
              <option *ngFor="let c of applicationRoles" value="{{ c['id'] }}">
                {{ c["name"] }}
              </option>
            </select>  -->

            <select #field class="form-control form-select-sm me-3" id="applicationRoleId"
              [disabled]="isSelectDisabled || form.data['email'] === undefined" (change)="
                checkDuplicate(
                  form.data['email'],
                  form.data['applicationRoleId'],
                  form.data['applicationId']
                )
              " name="applicationRole" [(ngModel)]="form.data['applicationRoleId']" required style="width: 200px">
              <!-- Always keep the first option as the default selected option -->
              <option value="undefined" disabled [selected]="form.data['applicationRoleId'] === undefined">
                --Application Role--
              </option>

              <!-- Loop through applicationRoles and add options dynamically -->
              <option *ngFor="let c of applicationRolesList" [value]="c['id']">
                {{ c["name"] }}
              </option>
            </select>

            <span style="color: red">{{ form.inputerror["applicationRoleId"] }}
            </span>

            <!-- Save Button -->
            <button (click)="save1()" type="button" class="btn btn-outline-primary btn-sm"
              [disabled]="uiForm.invalid || isInviteButtonDisabled">
              <i class="fas fa-envelope"></i> Invite
            </button>

            <!-- Error Messages -->
            <span class="text-danger ms-3">{{
              form.inputerror["applicationRoleId"]
              }}</span>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal" title="Close">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="appInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-grid" style="color: #4c5258; font-size: 20px; margin-right: 8px">
          </i>Application Information
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Key</th>
              <th scope="col">Values</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Organization</td>
              <td>{{ appInfo?.["orgName"] }}</td>
            </tr>
            <tr>
              <td>Usecase</td>
              <td>{{ appInfo?.usecaseName }}</td>
            </tr>
            <tr>
              <td>Skey</td>
              <td>{{ appInfo?.skey }}</td>
            </tr>
            <tr>
              <td>Version</td>
              <td>{{ appInfo?.version }}</td>
            </tr>
            <tr>
              <td>Created By:</td>
              <td>{{ appInfo?.createdBy }}</td>
            </tr>
            <tr>
              <td>Created Date:</td>
              <td>
                {{ appInfo?.createdDatetime | date : "MMM d, y, h:mm:ss a" }}
              </td>
            </tr>
            <tr>
              <td>Modified By:</td>
              <td>{{ appInfo?.modifiedBy }}</td>
            </tr>
            <tr>
              <td>Modified Date:</td>
              <td>
                {{ appInfo?.modifiedDatetime | date : "MMM d, y, h:mm:ss a" }}
              </td>
            </tr>
            <tr>
              <td>Version History:</td>
              <td>{{ appInfo?.versionHistory }}</td>
            </tr>
            <tr>
              <td>Archive Enabled:</td>
              <td>{{ appInfo?.archiveEnabled }}</td>
            </tr>
            <tr>
              <td>Change Log:</td>
              <td>{{ appInfo?.changeLog }}</td>
            </tr>
            <tr>
              <td>Group Filter:</td>
              <td>{{ appInfo?.groupFilter }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>